import React from 'react';

const Projects = () => {

  const projects = [
    {
      id: '#07',
      title: 'Tauwerk gedreht_Lavender Rosa',
      image: '/img/leine2_neu_optimized.jpg'
    },
    {
      id: '#048',
      title: 'Tauleine_Orange Poem',
      image: '/img/leine3_neu_optimized.jpg'
    },
    {
      id: '#006',
      title: 'Halsband_Coral Rosa',
      image: '/img/leine4_neu_optimized.jpg'
    },
    {
      id: '#061',
      title: 'Tauleine_Sea Green',
      image: '/img/leine5_neu_optimized.jpg'
    },
    {
      id: '#041',
      title: 'Tauleine_Candy Rosa',
      image: '/img/leine6_neu_optimized.jpg'
    }
  ];

  return (
    <section 
      id="projects" 
      className="py-32 px-8 bg-zinc-800 min-h-screen max-md:py-20 max-md:px-6"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-20">
          <h2 className="font-display text-[3.5rem] font-bold text-white tracking-tighter leading-tight relative inline-block max-md:text-[2.75rem] max-md:tracking-tight">
          Seil<span className="text-crimson">werke</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`group bg-zinc-700 border border-zinc-600 rounded-xl overflow-hidden transition-all duration-300 ease-out hover:border-crimson hover:shadow-[0_10px_40px_rgba(220,38,38,0.3)] ${
                projects.length % 2 !== 0 && index === projects.length - 1 
                  ? 'md:col-span-2 md:max-w-[calc(50%-1rem)] md:mx-auto' 
                  : ''
              }`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover scale-105 md:scale-100 transition-transform duration-500 ease-out md:group-hover:scale-105"
                />
              </div>
              <div className="p-5 bg-zinc-700">
                <span className="font-sans text-2xl font-extrabold block mb-2 text-crimson tracking-tight">
                  {project.id}
                </span>
                <h3 className="font-sans text-lg font-bold text-white tracking-tight leading-tight">
                  {project.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;

